<template>
  <div class="yimiao">
    <div>
      <div>
        <!-- 标题信息 -->
        <van-cell-group>
          <van-field v-model="datafrom.title" required label="标题" placeholder="请输入标题" />
        </van-cell-group>
        <van-cell-group >
          <van-field v-model="datafrom.phone" label="联系电话" required placeholder="请输入联系电话" />
        </van-cell-group>
        <!-- 富文本编辑器 -->
        <div class="submit" style="padding: 10px 7px" >
          <span style="color: red; font-size: 14px; letter-spacing: 8px"></span>
          <span style="color: #646566; font-size: 14px">内容</span>
        </div>
        <div style="width:90%;margin:auto;" required>
          <Editor :value.sync="datafrom.content" />
        </div>
      </div>
      <!-- <div class="buttons">
            <van-button type="info" @click="postfrom()">提交</van-button>
          </div> -->

      <div class="buttons">
        <van-button type="info" style="margin: 10px 0" @click="postfrom(1)">提交</van-button>
        <van-button style="border: 1px solid #e6e6e6; margin: 10px 0" type="
              default" @click="fanhui()">返回</van-button>
      </div>
    </div>
  </div>
</template>
  <script>
  import Vue from 'vue'
  import { Dialog } from 'vant'
  import { Toast } from 'vant'
  Vue.use(Toast)
  import { addLessee,getLessee} from '@/api/Changan-zhsq/evaluating'
  import Editor from "@/components/EditorUser";
  export default {
    components: {
      [Dialog.Component.name]: Dialog.Component,
      Editor
    },
    data() {
      return {
        datafrom: {
          phone: '', // 手机、
          // 新增的字段
          content:'',//富文本内容
          title:'',//标题
        },
      }
    },
    created() {
      this.openId = this.$route.query.openid
      console.log(this.openId,5555)
      if(this.$route.params.id && this.$route.params.id!='null' && this.$route.params.id!='undefined'){
        this.wxGetPromotion()
      }else{
        this.$route.params.id = ''
      }
    },

    methods: {
      wxGetPromotion() {
      this.goodsid = this.$route.params.id;
        let params={
          id:this.goodsid,
          openId: this.$route.query.openid
        }
      getLessee(params).then((res) => {
        console.log(res);
        this.datafrom = res.data.data;
        console.log(this.datafrom, "this.details");
        // this.getshoppingList(this.orderid);
      });
    },
      // 提交
      postfrom: function(row) {
        console.log(this.datafrom, 'dzx123123')
          if (this.datafrom.title == '') {
            Toast.fail('请输入标题')
            return false
          }
          if (this.datafrom.content == '') {
            Toast.fail('请输入内容')
            return false
          }
          if (this.datafrom.TouchTel == '') {
            Toast.fail('请输入联系电话')
            return false
          }
          this.datafrom.status = 0
        this.datafrom.openId =  this.openId
        // this.datafrom.WorkTime = this.WorkTime.join("-");
        // this.datafrom.IsMonitor = Number(this.datafrom.IsMonitor);
          addLessee(this.datafrom).then((res) => {
            if (res.data.code == 0) {
              console.log(this.datafrom, 'dzx1234567890')
              console.log(res.data)
              Dialog.alert({
                title: '提示',
                message: '提交成功!',
              }).then(() => {
                if (window.__wxjs_environment === "miniprogram") {
                   window.wx.miniProgram.navigateBack({
                        delta:1
                    });
                 } else {
                  this.$router.go(-1)
                }

                // this.$router.push({
                //   name: "register",
                // });
              })
            } else {
              Dialog.alert({
                title: '提示',
                message: '提交失败!' + res.data.msg,
              }).then(() => {
                // this.datafrom.IsMonitor = this.datafrom.IsMonitor + "";
                // on close
              })
            }
          })
      },
      fanhui: function() {
        if (window.__wxjs_environment === "miniprogram") {
                   window.wx.miniProgram.navigateBack({
                        delta:1
                    });
                 } else {
                  this.$router.go(-1)
                }
      },
      dateformat(val) {
        // 时间格式化事件 yy-mm-dd
        // let year = val.getFullYear();
        // let month = val.getMonth() + 1;
        // let day = val.getDate();
        let houser = val.getHours()
        let Minutes = val.getMinutes()
        if (month >= 1 && month <= 9) {
          month = `0${month}`
        }
        if (day >= 1 && day <= 9) {
          day = `0${day}`
        }
        if (houser >= 1 && houser <= 9) {
          houser = `0${houser}`
        }
        if (Minutes >= 1 && Minutes <= 9) {
          Minutes = `0${Minutes}`
        }
        // return `${year}-${month}-${day} ${houser}:${Minutes}`;
        return `${year}-${month}-${day}`
      },
    },

  }
  </script>
<style>
.imgs {
  margin: 0 15px;
}

.yimiao .inputFrom {
  margin: 15px 8%;
}

.yimiao .inputFrom input {
  width: 80%;
  margin: 8px 8%;
  padding: 8px 5px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
}

.yimiao .buttons {
  text-align: center;
}

.yimiao .buttons button {
  width: 90%;
  margin: 25px 5%;
  border-radius: 10px;
}

.buttons {
  text-align: center;
}

.buttons button {
  margin: 25px 10px;
  border-radius: 10px;
}
</style>
